// src/com/user_alloc/UserAllocCheck.js
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
//import { styled } from '@mui/material/styles';
import {
    Button, DialogContent, DialogActions, Grid, CircularProgress
} from '@mui/material';
import { AppObject, AppStyle, InputType } from '../../value/AppConst';
import VzmTextField from '../../common/VzmTextField';
import {  ErrorHintBox } from '../../common/VzmStyled';
import InputUtil from '../../value/InputUtil';
import IsValid from '../../value/IsValid';
import DraggableEditor from '../../common/DraggableEditor';
import { useLazyQuery } from '@apollo/client';
import { GET_USER_ALLOC_BY_ID } from './UserAllocGql';
import { useAlertSetter } from '../../api/app-hook';

const InputMap = {
    // toAdd, toEdit : mark if need to submit for mutation
    userId : {
        id: 'userId', label: '사용자ID',
        type: InputType.text, required: true, toAdd: true, toEdit: true,
        help: '25자 이내로 입력하세요.',
        check: (value) => {return IsValid.string(value, 0, 25)},
    },
};

const WaitingMessage = "사용자 아이디에 대해 승인상태를 확인합니다.";

/**
 * (USER_ALLOC) 사용자 등록관련 승인여부 확인하기.
 * 로그인 화면(AppLogin.js) 아래에 있는 버튼을 누르면 활성화.
 * Using React with MUI5
 * Project: NewTOP for cloud
 */
export default function UserAllocCheck({
    open,
    onClose,
}) {
    const [input, setInput] = useState({...AppObject.emptyInputData});
    const [item, setItem] = useState(null);
    const [done, setDone] = useState(false);
    const addAlert = useAlertSetter();

    useEffect(() => {
        if(open) {
            setInput({...AppObject.emptyInputData});
            setItem(null);
            setDone(false);
        }
    }, [open]);

    const [getUserAllocById, resultGet] = useLazyQuery(GET_USER_ALLOC_BY_ID, {
        onCompleted: (data, option) => onCompleteGetUserAlloc(data, option),
        onError: (error) => addAlert({title: '승인상태 조회 오류', message: error.message })
    });

    const onCompleteGetUserAlloc = (data, clientOption) => {
        setDone(true);
        if(data.userAllocItemById) {
            setItem(data.userAllocItemById);
        }
        else setItem(null);
    }

    const onChangeValue = (id, value, error) => {
        const newInput = InputUtil.reflectData(input, id, value, error, InputMap, false);
        setInput(newInput);
        setDone(false);
    };

    const onClickSubmit = () => {
        getUserAllocById({variables: {userId: input.data.userId}});
    };

    const onClickCancel = () => {
        onClose();
    };

    const renderMessage = () => {
        if(!done) return WaitingMessage;
        if(item) {
            if(item.allocFlag==='0') {
                return "승인 대기 중입니다.";
            }
            else if(item.allocFlag==='1') {
                return "승인되었습니다.";
            }
            else if(item.allocFlag==='2') {
                return "승인 거절되었습니다.";
            }
            else return "알 수 없는 승인상태입니다. 관리자에게 문의하세요.";
        }
        return "입력한 사용자 아이디로 조회된 결과가 없습니다.";
    };

    // Input field initiallized using getInputField(c,t,i)
    return(
        <DraggableEditor open={open} maxWidth='md'
            onClose={onClickCancel}
            title="승인요청 확인"
        >
            <DialogContent>
                <Box style={{width: 560}}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <VzmTextField
                                dict={InputMap.userId}
                                value={input.data.userId}
                                onChange={onChangeValue}
                                fullWidth={true}
                            />
                        </Grid><Grid item xs={6}></Grid>
                        <Grid item xs={12}>
                            <Box style={{
                                border: '1px solid #ccc',
                                borderRadius:4, padding:10
                                }}
                            >
                                {renderMessage()}
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            {
                                item && item.allocFlag==='2'
                                ?
                                <Box style={{color:'red', fontSize:'0.9rem'}}>
                                    거절사유: {item.note?item.note:"없음"}
                                </Box>
                                : <span>&nbsp;</span>
                            }
                        </Grid>
                    
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions style={{display:'flex'}}>
                {
                    input.errorLabels && input.errorLabels.length > 0
                    ?
                    <ErrorHintBox>
                        확인: {input.errorLabels.join(', ')}
                    </ErrorHintBox>
                    : null
                }
                {
                    resultGet.loading
                    ?
                    <span>
                        <CircularProgress />
                        &nbsp;데이터 조회 중...
                    </span>
                    :
                    <>
                        <Button
                            onClick={onClickSubmit}
                            disabled={
                                input.hasError || !input.changed
                                || resultGet.loading
                            }
                            variant={AppStyle.mui.contained}
                            color={AppStyle.mui.primary}
                        >확인</Button>
                        <Button onClick={onClickCancel}
                            color={AppStyle.mui.warning}
                            variant={AppStyle.mui.contained}
                        >닫기</Button>
                    </>
                }
            </DialogActions>
        </DraggableEditor>
    );
}
